export { default, getServerSideProps } from 'pages/tv/opas';
